import { refs, domReady, booleanDataset } from '../modules/utils.js';

class MoonBar extends HTMLElement {
  static get observedAttributes() {
    return ['data-index'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-index') {
      const index = parseInt(newValue, 10);
      if (index >= 0) {
        this.refs.icons?.forEach((el, i) => booleanDataset(el, 'active', i === index));
      }
    }
  }

  async connectedCallback() {
    if (this.disconnected) return;

    await domReady();
    this.refs = refs(this);
    this.refs.editboxes = Array.from(document.querySelectorAll('.editbox1'));

    this.#listeners();

    this.parentElement.replaceWith(this);
  }

  disconnectedCallback() {
    this.disconnected = true;
  }

  #listeners() {
    this.refs.icons?.forEach((el) => {
      el.addEventListener('click', () => {
        const index = Array.from(this.refs.icons).indexOf(el);
        if (this.refs.editboxes[index]) {
          const element = this.refs.editboxes[index].parentElement;
          // element.style.position = 'relative';
          const top = element.getBoundingClientRect().top + window.pageYOffset - this.offsetHeight;
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
          // setTimeout(() => {
          //   element.style.position = null;
          // }, 1);
        }
      });
    });

    const intersectingElements = [];
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const target = entry.target;
        if (entry.isIntersecting && !intersectingElements.includes(target)) {
          intersectingElements.push(target);
        }
        if (!entry.isIntersecting && intersectingElements.includes(target)) {
          intersectingElements.splice(intersectingElements.indexOf(target), 1);
        }
        if (intersectingElements.length) {
          this.dataset.index = this.refs.editboxes.indexOf(intersectingElements[intersectingElements.length - 1]);
        }
      });
    }, {
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    this.refs.editboxes.forEach(editbox => {
      observer.observe(editbox);
    });
  }
}

customElements.define('moon-bar', MoonBar);
